/**
 * Short copy for portfolio detail scroll-spy (readable while scrolling).
 * Full paragraphs remain on project.* for static / SEO fallback.
 */

const BRAND_WEB = [
  {
    id: "overview",
    label: "Overview",
    type: "text",
    headline: "업종별 맞춤 홈페이지",
    body: "브랜드·업종에 맞는 구조, 디자인, 인터랙션까지 담은 제작 사례 모음입니다.",
  },
  {
    id: "problem",
    label: "Problem",
    type: "text",
    headline: "템플릿만으로는 부족하다",
    body: "업종마다 다른 신뢰 포인트와 운영 흐름이 필요합니다.",
  },
  {
    id: "solution",
    label: "Solution",
    type: "text",
    headline: "목적에 맞춘 기획·제작",
    body: "3D·모션·반응형까지 포함해 브랜드에 맞게 구현합니다.",
  },
  {
    id: "features",
    label: "Key Features",
    type: "features",
    headline: "핵심 기능",
    items: ["업종별 맞춤 기획·제작", "3D·모션 UI", "반응형 퍼블리싱", "예약·문의 연동"],
  },
  {
    id: "ui-concept",
    label: "UI Concept",
    type: "text",
    headline: "브랜드 맞춤 UI",
    body: "틀에 맞추지 않고, 업종별 톤과 정보 우선순위를 새로 설계합니다.",
  },
  {
    id: "expected-result",
    label: "Expected Result",
    type: "text",
    headline: "직관적인 신뢰 전달",
    body: "제작 역량과 확장 가능성을 짧은 시간 안에 보여줍니다.",
  },
];

const AI_CODE_REVIEW = [
  {
    id: "overview",
    label: "Overview",
    type: "text",
    headline: "AI 코드 리뷰 플랫폼",
    body: "제출 → AI 분석 → 강사 피드백까지 한 흐름으로 연결합니다.",
  },
  {
    id: "problem",
    label: "Problem",
    type: "text",
    headline: "피드백 지연·운영 분산",
    body: "강사 부담은 크고, 학습자는 같은 실수를 반복합니다.",
  },
  {
    id: "solution",
    label: "Solution",
    type: "text",
    headline: "AI 선분석 + 강사 집중",
    body: "핵심 피드백과 진도·품질을 한 대시보드에서 관리합니다.",
  },
  {
    id: "features",
    label: "Key Features",
    type: "features",
    headline: "핵심 기능",
    items: ["언어별 AI 분석", "개선 리포트", "클래스·학생 관리", "권한별 접근"],
  },
  {
    id: "ui-concept",
    label: "UI Concept",
    type: "text",
    headline: "제출·분석·피드백 한 화면",
    body: "에디터와 리뷰 패널을 나란히 배치해 흐름이 보이게 설계합니다.",
  },
  {
    id: "expected-result",
    label: "Expected Result",
    type: "text",
    headline: "학습 효율 개선",
    body: "검토 시간은 줄이고, 피드백 속도와 품질은 높입니다.",
  },
];

const EDTECH = [
  {
    id: "overview",
    label: "Overview",
    type: "text",
    headline: "교육 운영 통합 플랫폼",
    body: "강의·수강생·과제·알림을 하나의 시스템에서 운영합니다.",
  },
  {
    id: "problem",
    label: "Problem",
    type: "text",
    headline: "정보가 흩어져 있다",
    body: "엑셀·메신저·메일로 관리하면 누락과 중복이 생깁니다.",
  },
  {
    id: "solution",
    label: "Solution",
    type: "text",
    headline: "운영 흐름 통합",
    body: "과제·피드백·알림을 시스템 안에서 처리합니다.",
  },
  {
    id: "features",
    label: "Key Features",
    type: "features",
    headline: "핵심 기능",
    items: ["강의·커리큘럼 관리", "출결·진도 추적", "과제·피드백", "운영 대시보드"],
  },
  {
    id: "ui-concept",
    label: "UI Concept",
    type: "text",
    headline: "오늘 할 일이 보이는 UI",
    body: "카드형 클래스와 타임라인으로 현황을 바로 파악합니다.",
  },
  {
    id: "expected-result",
    label: "Expected Result",
    type: "text",
    headline: "반복 업무 감소",
    body: "운영 효율이 올라가고, 수강생 경험도 명확해집니다.",
  },
];

const BRAND_STORY = [
  {
    id: "overview",
    label: "Overview",
    type: "text",
    headline: "브랜드 스토리 홈페이지",
    body: "첫 방문자도 회사의 방향과 강점을 빠르게 이해합니다.",
  },
  {
    id: "problem",
    label: "Problem",
    type: "text",
    headline: "정보 나열은 기억에 안 남는다",
    body: "차별점과 신뢰 근거 없이는 다음 단계로 이어지기 어렵습니다.",
  },
  {
    id: "solution",
    label: "Solution",
    type: "text",
    headline: "스토리형 구조",
    body: "미션 → 해결 → 서비스 → 실적 순으로 설득 흐름을 만듭니다.",
  },
  {
    id: "features",
    label: "Key Features",
    type: "features",
    headline: "핵심 기능",
    items: ["미션·비전 섹션", "서비스 카드", "실적·신뢰 지표", "문의 CTA"],
  },
  {
    id: "ui-concept",
    label: "UI Concept",
    type: "text",
    headline: "몰입형 스크롤",
    body: "비주얼과 글래스 패널을 교차해 스토리를 전달합니다.",
  },
  {
    id: "expected-result",
    label: "Expected Result",
    type: "text",
    headline: "문의 전환 강화",
    body: "브랜드 신뢰와 파트너 문의 가능성을 높입니다.",
  },
];

const ADMIN_PAGE = [
  {
    id: "overview",
    label: "Overview",
    type: "text",
    headline: "통합 관리자 대시보드",
    body: "회원·콘텐츠·문의·권한을 브라우저에서 바로 처리합니다.",
  },
  {
    id: "problem",
    label: "Problem",
    type: "text",
    headline: "수동 운영의 리스크",
    body: "도구가 분산되면 지연·실수·보안 취약점이 커집니다.",
  },
  {
    id: "solution",
    label: "Solution",
    type: "text",
    headline: "역할 기반 통합 관리",
    body: "필요한 작업만 빠르게, 검색·필터로 즉시 확인합니다.",
  },
  {
    id: "features",
    label: "Key Features",
    type: "features",
    headline: "핵심 기능",
    items: ["회원·권한 관리", "CMS 연동", "문의 티켓", "활동 로그"],
  },
  {
    id: "ui-concept",
    label: "UI Concept",
    type: "text",
    headline: "실무형 테이블 UI",
    body: "사이드바 + 데이터 테이블로 운영 업무에 최적화합니다.",
  },
  {
    id: "expected-result",
    label: "Expected Result",
    type: "text",
    headline: "안정적인 운영",
    body: "처리 속도와 권한 추적이 명확해집니다.",
  },
];

const DASHBOARD = [
  {
    id: "overview",
    label: "Overview",
    type: "text",
    headline: "비즈니스 분석 대시보드",
    body: "핵심 KPI와 추이를 한 화면에서 확인합니다.",
  },
  {
    id: "problem",
    label: "Problem",
    type: "text",
    headline: "데이터가 흩어져 있다",
    body: "시트·보고서가 분리되면 의사결정이 늦어집니다.",
  },
  {
    id: "solution",
    label: "Solution",
    type: "text",
    headline: "지표 통합·필터링",
    body: "기간·채널·세그먼트별로 바로 비교합니다.",
  },
  {
    id: "features",
    label: "Key Features",
    type: "features",
    headline: "핵심 기능",
    items: ["KPI 카드", "추이 차트", "퍼널 분석", "리포트 공유"],
  },
  {
    id: "ui-concept",
    label: "UI Concept",
    type: "text",
    headline: "한눈에 읽히는 레이아웃",
    body: "다크 배경 + 글래스 카드로 데이터를 연결합니다.",
  },
  {
    id: "expected-result",
    label: "Expected Result",
    type: "text",
    headline: "빠른 의사결정",
    body: "이슈를 조기에 발견하고 대응할 수 있습니다.",
  },
];

export const PORTFOLIO_SCROLL_SECTIONS = {
  "brand-web": BRAND_WEB,
  "ai-code-review": AI_CODE_REVIEW,
  edtech: EDTECH,
  "brand-storytelling": BRAND_STORY,
  "admin-page": ADMIN_PAGE,
  dashboard: DASHBOARD,
};

export function getPortfolioScrollScenes(slug) {
  return PORTFOLIO_SCROLL_SECTIONS[slug] ?? null;
}

/** Shared visual for scroll panel (building brand image). */
export const PORTFOLIO_SCROLL_VISUAL = "/portfolio/detail-scroll-visual.webp";
